<template>
    <div>
        <b-sidebar
            v-show="viewTypeIsWeb"
            id="sidebar-dashboard"
            v-model="editModeModel"
            title="Sidebar"
            no-header
            shadow
        >
            <template>
                <b-button
                    id="sidebar-no-header-title"
                    block
                    @click.capture="hideSidebar"
                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    variant="flat-primary"
                    class="mt-1 mb-1 ml-2 w-auto px-50 py-50"
                >
                    <feather-icon
                        icon="ArrowLeftIcon"
                    />
                    Dashboard
                </b-button>
                <div class="px-2 py-2">
                    <WidgetCheckbox />
                </div>
            </template>
        </b-sidebar>
        <component
            :is="renderComponent"
        >
        </component>
    </div>
</template>

<script>
import WidgetCheckbox from '@/modules/Dashboard/_components/WidgetCheckbox.vue'
import { ref, computed, watch, onUnmounted } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import useDashboardRender from '@/composables/useDashboardRender'
import useDashboardHeader from '@/composables/useDashboardHeader'
const Dashboard = () => import('./_components/Dashboard.vue')
const DashboardEdit = () => import('./_components/DashboardEdit.vue')
export default {
    directives: {
        Ripple
    },
    components: {
        Dashboard,
        DashboardEdit,
        WidgetCheckbox
    },
    setup () {
        const { viewType } = useDashboardRender()
        const { isEditMode, updateEditMode, cancelDashboard } = useDashboardHeader()
        const editModeModel = ref(isEditMode.value)
        const renderComponent = computed(() => editModeModel.value ? 'dashboard-edit' : 'dashboard')
        const viewTypeIsWeb = computed(() => viewType.value === 'web')
        const hideSidebar = () => cancelDashboard()
        watch(isEditMode, (value, oldValue) => {
            editModeModel.value = value
        })
        onUnmounted(() => {
            updateEditMode(false)
        })
        return {
            editModeModel,
            renderComponent,
            hideSidebar,
            viewTypeIsWeb
        }
    }
}
</script>

<style>
.vue-grid-item {
    border-radius: 8px;
}
</style>
